// extracted by mini-css-extract-plugin
export default {"serviceCategoriesBuilder":"serviceCategoriesBuildertQZp7"};